// Action creators
import { readJson } from './apiResponse';

var fetchPreferences = () => {
    return function (dispatch) {
        const token = localStorage.token;
        if (!token) {
            return Promise.resolve();
        }

        return fetch('api/Preference/Mine', {
            method: "GET",
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(results => readJson(results, 'api/Preference/Mine'))
            .then(json => {
                if (!json) {
                    return;
                }
                dispatch({ type: 'PREFERENCES_LOAD', payload: json });
            })
            .catch(err => console.error('fetchPreferences failed:', err));
    };
}

// items: [{ category, name, value }]. The server derives the user from the
// request, so nothing here sends a user id.
var savePreferences = (items) => {
    return function (dispatch) {
        const token = localStorage.token;
        if (!token) {
            return Promise.resolve();
        }

        return fetch('api/Preference/UpsertMany', {
            method: "POST",
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ items: items })
        })
            .then(results => readJson(results, 'api/Preference/UpsertMany'))
            .then(json => {
                // Resolves true/false rather than swallowing the outcome: the
                // panel shows the new value immediately and has to know when
                // to put it back.
                if (!json) {
                    return false;
                }
                dispatch({ type: 'PREFERENCES_LOAD', payload: json });
                return true;
            })
            .catch(err => {
                console.error('savePreferences failed:', err);
                return false;
            });
    };
}

export default {
    'FETCH_PREFERENCES': fetchPreferences,
    'SAVE_PREFERENCES': savePreferences,
};



// WEBPACK FOOTER //
// ./src/actions/preference_actions.js